<template>
  <div class="horoscope">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Horoscope'
}
</script>
